<div class="d-flex flex-column h-100 np-scrollable">
  <div *ngIf="validationService.showValidationSummary('feature')" class="np-validation-summary">
    <div class="np-validation-summary-header">
      <i class="dx-icon dx-icon-warning"></i>
      <span>{{ 'Validierung' | translate }}</span>
    </div>
    <ul class="np-validation-summary-list">
      <li *ngFor="let item of validationService.consolidatedValidationMessages('feature')">
        {{ item.message }}<span *ngIf="item.count > 1"> ({{ item.count }})</span>
      </li>
    </ul>
  </div>

  <div class="flex-grow-1 overflow-auto">
    <dx-accordion class="np-accordion"
                  [dataSource]="featureSystems"
                  itemTemplate="itemTemplate"
                  [collapsible]="true"
                  [multiple]="false"
                  noDataText="{{ 'keine FeatureSysteme vorhanden' | translate }}"
                  [selectedIndex]="-1"
                  (onItemTitleClick)="onAccordionItemClick($event)">
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="FeatureSystemsStateNewUI3"/>
      <dxo-pager [visible]="true"></dxo-pager>

      <div *dxTemplate="let featureSystem of 'title'">
        <div class="np-accordion-title">
          @if (!featureSystem.editMode) {
            <div>
              {{ featureSystem.order }}. {{ featureSystem.referenceFeatureSystemName | translate }}
              <span *ngIf="loginService.currentUser.featureProfiMode && (featureSystem.referenceFeatureGroupId || featureSystem.referenceFeatureGroupName)"
                    class="position-relative">
                {{ ' | ' }}
                @if (featureSystem.referenceFeatureGroupId) {
                  <span [ngStyle]="{ color: 'var(--dx-color-primary)' }">
                    <b>{{ 'ID' | translate }}:</b>
                    {{ featureSystem.referenceFeatureGroupId }}
                  </span>
                }
                @if (featureSystem.referenceFeatureGroupName) {
                  @if (featureSystem.referenceFeatureGroupId) {
                    {{ ' | ' }}
                  }
                  <span [ngStyle]="{ color: 'var(--dx-color-primary)' }">
                    <b>{{ 'Name' | translate }}:</b>
                    {{ featureSystem.referenceFeatureGroupName }}
                  </span>
                }
              </span>

              @if (featureSystem.features) {
                {{ ' (' + featureSystem.features.length + ')' }}
              }
            </div>
          } @else {

            <div>
              <np-inputControl
                  [showPlaceLabel]="featureSystem?.order != null"
                  [suppressLabel]="true"
                  [suppressTranslation]="true"
                  [suppressToolTip]="true"
                  (elementSelected)="
                templateSelectionEnabled ? templateSelect($event, getRelevantSystemKey(featureSystem)) : null
              "
                  (onValueChanged)="update($event)"
                  labelText="{{ 'Order' | translate }}"
                  field="FS_ORDER"
                  [system]="getRelevantSystemKey(featureSystem)"
                  [showDragHandle]="context?.showDragHandle && featureSystemIsValid(featureSystem)"
              >
                <div slot="content" class="contentSlot">
                  <dx-number-box
                      [(value)]="featureSystem.order"
                      [min]="1"
                      [showClearButton]="false"
                      [showSpinButtons]="!readOnlyForLinkedFields('FS_ORDER', featureSystem.validFeatureSystemId)"
                      [readOnly]="
                    readOnlyForLinkedFields('FS_ORDER', featureSystem.validFeatureSystemId) ||
                    readOnly('editfeatureOrder') ||
                    readOnlyTemplateEditor(featureSystem)
                  "
                      (onValueChanged)="update($event, featureSystem, 'FS_ORDER', featureSystem.validFeatureSystemId)"
                  ></dx-number-box>
                </div>
              </np-inputControl>
            </div>

            <div>
              <np-inputControl
                  [showPlaceLabel]="featureSystem?.referenceFeatureSystemName?.length > 0"
                  [suppressLabel]="true"
                  (elementSelected)="
                templateSelectionEnabled ? templateSelect($event, getRelevantSystemKey(featureSystem)) : null
              "
                  (onValueChanged)="update($event)"
                  field="REFERENCE_FEATURE_SYSTEM_NAME"
                  [system]="getRelevantSystemKey(featureSystem)"
                  [showDragHandle]="context?.showDragHandle && featureSystemIsValid(featureSystem)"
                  (excelElementDropped)="excelElementDrop($event)"
              >
                <div slot="content" class="contentSlot">
                  <dx-select-box
                      [(value)]="featureSystem.referenceFeatureSystemName"
                      [showClearButton]="
                    showClearButton(
                      'REFERENCE_FEATURE_SYSTEM_NAME',
                      featureSystem.validFeatureSystemId,
                      'editfeatureSystemName'
                    )
                  "
                      [readOnly]="
                    hasFeatureSystemFieldLinked(featureSystem.validFeatureSystemId) || readOnly('editfeatureSystemName') ||
                    isSystemNameMappedToExcelColumn(featureSystem)
                  "
                      (onValueChanged)="updateFeatureSystemNameAndUpdate($event, featureSystem)"
                      validationMessageMode="always"
                      validationMessagePosition="top"
                      [minSearchLength]="0"
                      [searchEnabled]="true"
                      [acceptCustomValue]="true"
                      placeholder=""
                      [dataSource]="featureSystemNameSource"
                  >
                    <dx-validator
                        *ngIf="!templateView && context?.model?.id"
                        validationGroup="FEAT"
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                    >
                      <dxi-validation-rule
                          type="async"
                          [validationCallback]="
                        validationService.validateField(
                          'REFERENCE_FEATURE_SYSTEM_NAME',
                          getRelevantSystemKey(featureSystem)
                        )
                      "
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-select-box>
                </div>
              </np-inputControl>
            </div>

            <div *ngIf="loginService.currentUser.featureProfiMode" style="max-width: 30%">
              <np-inputControl
                  [showPlaceLabel]="featureSystem?.referenceFeatureGroupId?.length > 0"
                  [suppressLabel]="true"
                  (elementSelected)="
                templateSelectionEnabled ? templateSelect($event, getRelevantSystemKey(featureSystem)) : null
              "
                  (onValueChanged)="update($event)"
                  field="REFERENCE_FEATURE_GROUP_ID"
                  [system]="getRelevantSystemKey(featureSystem)"
                  [showDragHandle]="context?.showDragHandle && featureSystemIsValid(featureSystem)"
                  (excelElementDropped)="excelElementDrop($event)"
              >
                <div slot="content" class="contentSlot">
                  <dx-text-box
                      validationMessagePosition="top"
                      [(value)]="featureSystem.referenceFeatureGroupId"
                      [showClearButton]="showClearButton('REFERENCE_FEATURE_GROUP_ID', featureSystem.validFeatureSystemId)"
                      [readOnly]="
                    readOnlyForLinkedFields('REFERENCE_FEATURE_GROUP_ID', featureSystem.validFeatureSystemId) ||
                    readOnly('editfeatureGroupId') ||
                    readOnlyTemplateEditor(featureSystem)
                  "
                      (onValueChanged)="
                    update($event, featureSystem, 'REFERENCE_FEATURE_GROUP_ID', featureSystem.validFeatureSystemId)
                  "
                  >
                    <dx-validator
                        *ngIf="!templateView && context?.model?.id"
                        validationGroup="FEAT"
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                    >
                      <dxi-validation-rule
                          type="async"
                          [validationCallback]="
                        validationService.validateField('REFERENCE_FEATURE_GROUP_ID', getRelevantSystemKey(featureSystem))
                      "
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </np-inputControl>
            </div>

            <div *ngIf="loginService.currentUser.featureProfiMode" style="max-width: 30%">
              <np-inputControl
                  [showPlaceLabel]="featureSystem?.referenceFeatureGroupName?.length > 0"
                  [suppressLabel]="true"
                  (elementSelected)="
                templateSelectionEnabled ? templateSelect($event, getRelevantSystemKey(featureSystem)) : null
              "
                  (onValueChanged)="update($event)"
                  field="REFERENCE_FEATURE_GROUP_NAME"
                  [system]="getRelevantSystemKey(featureSystem)"
                  [showDragHandle]="context?.showDragHandle && featureSystemIsValid(featureSystem)"
                  (excelElementDropped)="excelElementDrop($event)"
              >
                <div slot="content" class="contentSlot">
                  <dx-text-box
                      validationMessagePosition="top"
                      [(value)]="featureSystem.referenceFeatureGroupName"
                      [showClearButton]="showClearButton('REFERENCE_FEATURE_GROUP_NAME', featureSystem.validFeatureSystemId)"
                      [readOnly]="
                    readOnlyForLinkedFields('REFERENCE_FEATURE_GROUP_NAME', featureSystem.validFeatureSystemId) ||
                    readOnly('editfeatureGroupName') ||
                    readOnlyTemplateEditor(featureSystem)
                  "
                      (onValueChanged)="
                    update($event, featureSystem, 'REFERENCE_FEATURE_GROUP_NAME', featureSystem.validFeatureSystemId)
                  "
                  >
                    <dx-validator
                        *ngIf="!templateView && context?.model?.id"
                        validationGroup="FEAT"
                        (onInitialized)="validationService.startAutomaticValidation($event)"
                    >
                      <dxi-validation-rule
                          type="async"
                          [validationCallback]="
                        validationService.validateField('REFERENCE_FEATURE_GROUP_NAME', getRelevantSystemKey(featureSystem))
                      "
                      ></dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </np-inputControl>
            </div>
          }

          <div *ngIf="!featureSystem.editMode" class="d-flex flex-grow-1 gap-1 mx-3">
            <dx-button
                stylingMode="text"
                type="default"
                icon="edit"
                (onClick)="toggleFeatureSystemEditMode($event, featureSystem)"/>
            <dx-button
                style="margin-left: auto"
                stylingMode="text"
                type="default"
                icon="trash"
                [disabled]="readOnly('editfeatureSystemDelete')"
                (onClick)="onDeleteClick($event, featureSystem)"/>
          </div>

          <div *ngIf="featureSystem.editMode" class="mx-3">
            <dx-button
                stylingMode="text"
                type="default"
                icon="check"
                (onClick)="toggleFeatureSystemEditMode($event, featureSystem)"
            />
          </div>
        </div>
      </div>

      <div *dxTemplate="let featureSystem of 'itemTemplate'">
          <features
              [featureSystem]="featureSystem"
              [templateView]="templateView"
              [displayMode]="displayMode"
              (onValueChanged)="update($event)"
              (elementSelected)="templateChildSelected($event)"
              (excelElementDropped)="excelElementDrop($event)"
              (elementDeleted)="deleteFeature($event)"
          ></features>
      </div>
    </dx-accordion>

    <dx-popup
        [width]="850"
        [height]="750"
        [showTitle]="true"
        title="{{ 'Klassifizieren' | translate }}"
        [dragEnabled]="false"
        [hideOnOutsideClick]="true"
        [showCloseButton]="true"
        [(visible)]="classificationPopupVisible"
        contentTemplate="popupContent"
    >
      <div *dxTemplate="let data of 'popupContent'">
        <productClassification
            (windowClose)="closeClassificationPopup()"
            (addEcommerceFeatures)="emitAddEcommerceFeatures()"
            (addClassificationFeatures)="emitAddClassificationFeatures($event)"
        ></productClassification>
      </div>
    </dx-popup>
  </div>
</div>
<footer class="np-footer d-flex">
  <dx-button
      *ngIf="canView('editFeatureNew')"
      stylingMode="outlined"
      type="default"
      text="{{ 'Neue Merkmalsgruppe' | translate }}"
      [disabled]="updateLock || readOnly('editFeatureNew')"
      (onClick)="addFeatureSystemButtonClicked()"
  ></dx-button>

  <dx-button
      *ngIf="canView('editFeatureClassification')"
      stylingMode="outlined"
      type="default"
      text="{{ 'Klassifizieren' | translate }}"
      (onClick)="addClassificationButtonClicked()"
  ></dx-button>

  <div style="margin-left: auto; margin-right: 5px;">
      <span>
        {{ 'Einfach' | translate }}
      </span>

    <dx-switch
        [(value)]="loginService.currentUser.featureProfiMode"
        switchedOffText="{{ 'Einfach' | translate }}"
        switchedOnText="{{ 'Fortgeschritten' | translate }}"
        hint="{{ 'Selten genutzte Felder aktivieren' | translate }}"
    ></dx-switch>

    <span>
        {{ 'Fortgeschritten' | translate }}
      </span>
  </div>
</footer>